/**
 * Human name for a route, for feedback reports.
 *
 * Kept as a small table rather than derived from the path, because a raw path
 * is the wrong unit for a person reading a queue: `/idea/9f3a…` says nothing,
 * and `/launch` reads as a deploy rather than the screen a founder actually
 * saw. The stored `path` still carries the exact route — this is the label
 * that makes a report legible at a glance.
 *
 * Dynamic segments are matched by prefix so an id never becomes part of the
 * name. Unknown routes fall back to the path itself rather than to a generic
 * placeholder: an unmapped screen should look unmapped, so it gets a name here
 * instead of quietly reading as "App".
 */
const EXACT: Record<string, string> = {
  '/': 'Landing page',
  '/auth': 'Sign in / create account',
  '/auth/reset': 'Reset password',
  '/capture': 'Interview',
  '/launch': 'Brief and scan',
  '/ideas': 'Your ideas',
};

const PREFIX: [string, string][] = [['/idea/', 'Idea dashboard']];

export function screenNameFor(pathname: string): string {
  const exact = EXACT[pathname];
  if (exact) return exact;

  for (const [prefix, name] of PREFIX) {
    if (pathname.startsWith(prefix)) return name;
  }

  return pathname;
}
